// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O3nZ","top":"styles_top__1cW66","left":"styles_left__1DFuH","description":"styles_description__1407B"};